import React, { useEffect } from "react";
import PropTypes from "kf-proptypes/account";
import { Trans } from "@lingui/macro";

import { loadRecaptcha } from "base/utils";
import { KissflowLogoIcon } from "widgets/kfothericon";
import { Link } from "widgets/navigation";

import styles from "./style.css";

import WelcomeIllustrationBGIcon from "../../assets/WelcomeIllustration.svg";

export const Wrapper = ({ children, className, showBGImage = true }) => {
  useEffect(function loadCaptcha() {
    loadRecaptcha();
  }, []);

  return (
    <div className={`${styles.loginWrapper} ${className}`}>
      <div className={styles.scrollBar}>
        {children}
        <Footer />
      </div>
      {showBGImage && (
        <WelcomeIllustrationBGIcon
          className={styles.welcomeIllustrationContainer}
        />
      )}
    </div>
  );
};

const Body = ({ children, className }) => (
  <div className={`shadow-8dp ${styles.loginCard} ${className}`}>
    {children}
  </div>
);

const Logo = ({ url, className }) => {
  if (!url) {
    return null;
  }
  return (
    <div className={`${styles.logoContainer} ${className}`}>
      <img src={url} alt="Company Logo" />
    </div>
  );
};

const Title = ({ children, className }) => (
  <p className={`h4600 ${styles.title} ${className}`}>{children}</p>
);

const Footer = () => {
  return (
    <div className={styles.footerContainer}>
      <div className={styles.separatorLine} />
      <span className="small">
        <Trans>Powered by</Trans>
      </span>
      <Link href="https://kissflow.com/?utm_source=login&utm_medium=referral&utm_campaign=kissflow-customers-login">
        <KissflowLogoIcon />
      </Link>
    </div>
  );
};

Wrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  showBGImage: PropTypes.bool
};

Body.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

Logo.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string
};

Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

Footer.propTypes = {
  isPortal: PropTypes.bool
};

Wrapper.Body = Body;
Wrapper.Logo = Logo;
Wrapper.Title = Title;
Wrapper.Footer = Footer;
